import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const namespaced = false

export default {
  namespaced,
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    token: localStorage.getItem('token')
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js